import axios from 'axios'

export default class Reports {


  async getReport(url, params) {
    const response = await axios.get(url, { params })
    return response.data
  }
}
